import React from "react";
import { useParams } from "react-router-dom";
import { ClientMealLoggingScreen } from "../../../components/client-meal-logging/ClientMealLoggingScreen";

export function ClientMealLoggingRoute() {
  const { date } = useParams();

  return <ClientMealLoggingScreen date={date} />;
}
